import { UnreadReportsStorage } from '../documents/unread-reports-storage';
import { Observable } from 'rxjs';
import { Settings } from '../core';
import { HttpClient } from '@angular/common/http';
import { CategoriesStorage, ReportsPackage, Report, CategoryNaturalKey } from '../documents';
import { UserStorage } from '../user';
import { Injectable } from '@angular/core';
import { GeneralDocumentsCounter, GeneralDocumentsCounterReadModel } from '../documents/models/documents-counter';

@Injectable()
export class GeneralUnreadReportsStorage extends UnreadReportsStorage<GeneralDocumentsCounter> {
    constructor(
        settings: Settings,
        http: HttpClient,
        categoriesStorage: CategoriesStorage,
        userStorage: UserStorage
    ) {
        super(settings, http, categoriesStorage, userStorage);
    }

    protected getUnreadCounters(): Observable<GeneralDocumentsCounter[]> {
        return this.loadUnreadCounters('documents-counters/general', GeneralDocumentsCounterReadModel);
    }

    protected recountOnDocumentsReading(updatedReports: ReportsPackage, unreadCounters: GeneralDocumentsCounter[]): GeneralDocumentsCounter[] {
        const recentlyReadReports: Report[] = updatedReports.reports.filter(report => !report.isRead);
        const currentCategoryId: CategoryNaturalKey = updatedReports.category.categoryId;

        const item = unreadCounters.find(r =>
            (r.rootCategoryId === currentCategoryId || r.categoryId === currentCategoryId)
        );

        if (item) {
            item.unreadCount -= recentlyReadReports.length;
        }

        return unreadCounters;
    }

    protected recountOnCountersUpdating(updatedReports: ReportsPackage, unreadCounters: GeneralDocumentsCounter[]): GeneralDocumentsCounter[] {
        const unreadReports: Report[] = updatedReports.reports.filter(report => !report.isRead);
        const currentCategoryId: CategoryNaturalKey = updatedReports.category.categoryId;

        const item = unreadCounters.find(r =>
            (r.rootCategoryId === currentCategoryId || r.categoryId === currentCategoryId)
        );

        if (item) {
            item.unreadCount = unreadReports.length;
        } else {
            const unreadData = new GeneralDocumentsCounter();
            unreadData.categoryId = currentCategoryId;
            unreadData.unreadCount = unreadReports.length;
            unreadData.totalDocs = updatedReports.reports.length;
            unreadCounters.push(unreadData);
        }

        return unreadCounters;
    }
}